import React, { memo, useCallback } from 'react';

import { DateFieldCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { toWorksheetDateValue } from './WorksheetDateField.utils';

/**
 * A worksheet date with its label above the box, like every other worksheet field (the extraction
 * form's date picker puts it inside).
 */
const WorksheetDateField = ({
  id,
  name,
  value = null,
  isRequired = false,
  disabled = false,
  error = null,
  setInForm,
  validateField,
}) => {
  const onChange = useCallback(
    date => {
      const nextValue = toWorksheetDateValue(date);

      setInForm(id, nextValue);
      validateField(id, nextValue);
    },
    [id, setInForm, validateField],
  );

  return (
    <DateFieldCDS
      clearable
      containerClassName="mb-16"
      dataTestId={`worksheet-date.${id}`}
      disabled={disabled}
      error={!!error}
      label={name}
      name={id}
      required={isRequired}
      value={value || null}
      onChange={onChange}
    />
  );
};

WorksheetDateField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setInForm: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

export default memo(WorksheetDateField);
